var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.3 119.5",
    style: {
      enableBackground: "new 0 0 119.3 119.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#87CDD3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.3,31.2c0-7.5,0-14.9,0-22.4c0-5.5-3.4-8.9-8.8-8.9H8.8C3.4,0,0,3.4,0,8.9v22.4l0,0v41.4l0,0v38.1 c0,0.7,0,1.3,0.1,2c0.8,4.2,4.1,6.8,8.6,6.8h73.7l0,0h27.9c4.5,0,7.3-2,8.6-6.3c0.1-0.2,0.1-0.3,0.2-0.5V78.6h0.1L119.3,31.2 L119.3,31.2z M111,77.8L111,77.8v33.5H47l0,0H8.3V72.7l0,0V31.2l0,0v-23H111v23l0,0V77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.5,55.8c-0.7-0.1-1.4-0.1-2.1-0.1H63.7v-3.3l0,0v-7.8l0,0V31c0-2.1,0-4.3,0-6.4c-0.1-2-1.7-3.6-3.7-3.8 c-2-0.1-3.8,1.2-4.2,3.1c-0.1,0.7-0.2,1.4-0.2,2.1v9.3l0,0v20.3h-3.3l0,0H30.9c-2.1,0-4.3,0-6.4,0c-2,0.1-3.6,1.7-3.7,3.7 c-0.1,2,1.2,3.8,3.1,4.2c0.7,0.1,1.4,0.2,2.1,0.1h29.6V67l0,0v7.8l0,0v13.7c0,2.2,0,4.3,0,6.4c0.1,2,1.7,3.6,3.7,3.7 c2,0.2,3.8-1.2,4.2-3.1c0.1-0.7,0.2-1.4,0.1-2.1v-9.3l0,0V63.8h24.8c2.1,0,4.3,0,6.4,0c2-0.1,3.6-1.7,3.7-3.7 C98.7,58.1,97.4,56.3,95.5,55.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIos);
export default __webpack_public_path__ + "static/media/add-ios.fc34d4c834dde412a067fcaa90ac4125.svg";
export { ForwardRef as ReactComponent };